import React from 'react';
import { Location } from 'history';
import Layout from 'components/layout';
import DealResults from 'components/deal-results';
import labels from 'constants/labels';
import { IDeal } from 'store/deals/types';

interface IDealCreatePageProps {
  createNewDeal: () => void;
  duplicateDeal: (deal: IDeal) => void;
  setPageTitle: (title: string) => void;
  location?: Location;
}

const DealCreatePage = ({ createNewDeal, duplicateDeal, location, setPageTitle }: IDealCreatePageProps) => {
  // Check for duplication scenario
  if (location?.state) {
    const { dealToDuplicate } = location.state;
    duplicateDeal(dealToDuplicate);
    setPageTitle(labels.titles.pages.dealDuplicate);
  } else {
    createNewDeal();
    setPageTitle(labels.titles.pages.dealCreate);
  }

  return (
    <Layout>
      <DealResults />
    </Layout>
  );
};

export default DealCreatePage;
